import Footer from "../../commons/footer";
import Header from "../../commons/header";
import ExperiencesMain from "./main";

const Experiences = () => {
    return (
        <div className="experiences-page">
            <Header />
            <ExperiencesMain />
            <Footer />
        </div>
    )
};

export default Experiences;